import { Injectable, Injector, inject } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetRegistryService } from '@frontend/sports/widget/core/feature';
import { OnFeatureInit } from '@frontend/vanilla/core';

import { MarqueeWidgetComponent } from './marquee-widget.component';
import { OutrightsMarqueeWidgetComponent } from './outrights-marquee-widget.component';

@Injectable({ providedIn: 'root' })
export class WidgetRegistrationService implements OnFeatureInit {
    private registry = inject(WidgetRegistryService);
    private injector = inject(Injector);

    onFeatureInit(): void {
        this.registry.registerLazy(WidgetType.Marquee, MarqueeWidgetComponent, this.injector);
        this.registry.registerLazy(WidgetType.OutrightsMarquee, OutrightsMarqueeWidgetComponent, this.injector);
    }
}
